import getCookie from './getCookie';
import { CookieName } from './constants';
/**
 * Returns the specified cookie value or undefined (see ./getCookie)
 * @param {Object | string }     context server context
 * @returns {string | undefined} cookie value
 */ const getAccessTokenCookie = (context)=>getCookie(CookieName.ACCESS_TOKEN, context);
export default getAccessTokenCookie;
